import { createContext, createElement, useState as useState$1 } from 'react';

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

const useState = useState$1;
function createContextIO(initialState) {
  const Context = createContext(initialState);
  const NativeProvider = Context.Provider;

  Context.Provider = (_ref) => {
    let children = _ref.children;

    const _useState = useState(initialState),
          _useState2 = _slicedToArray(_useState, 2),
          state = _useState2[0],
          setState = _useState2[1];

    Context.write = setState;

    Context.read = () => state;

    return createElement(NativeProvider, {
      value: state
    }, children);
  };

  Context.write = Context.read = () => {
    throw new Error('ContextIO not mount');
  };

  return Context;
}

export { createContextIO };
